import {createContext, useContext, useEffect, useState} from "react";
import {useMap, useMapsLibrary} from "@vis.gl/react-google-maps";
import {useParams} from "react-router";

export const AreaLayerContext = createContext(undefined);


const PointLayerProvider = ({children, setIsLoading, position, id}) => {
    const [icons, setIcons] = useState([])
    const [areas, setAreas] = useState([])

    const map = useMap();
    const markerLib = useMapsLibrary("marker");
    const coreLib = useMapsLibrary("core");
    const mapLib = useMapsLibrary("maps");

    return (
        <AreaLayerContext.Provider value={{
            map, setIsLoading, icons, setIcons, markerLib, coreLib, position,
            areas, setAreas, id, mapLib
        }}>
            {children}
        </AreaLayerContext.Provider>
    );
}

export default PointLayerProvider;